export var ComponentArea;
(function (ComponentArea) {
    ComponentArea["Editor"] = "editor-editor";
    ComponentArea["Themes"] = "themes";
    ComponentArea["EditorStack"] = "editor-stack";
})(ComponentArea || (ComponentArea = {}));
